/**
 * Labstep
 */

import { Action } from 'labstep-web/components/ExperimentWorkflow/Action/Menu';

export const actions = [
  Action.share,
  Action.duplicate,
  Action.revoke,
  Action.print,
  Action.lock,
  Action.tag,
  Action.transfer_ownership,
  Action.delete,
  Action.export,
  Action.assign,
  Action.add_to_folder,
  Action.remove_from_folder,
];
